import { render, staticRenderFns } from "./alocacao-estrategica.vue?vue&type=template&id=96316496&"
import script from "./alocacao-estrategica.vue?vue&type=script&lang=js&"
export * from "./alocacao-estrategica.vue?vue&type=script&lang=js&"
import style0 from "./alocacao-estrategica.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96316496')) {
      api.createRecord('96316496', component.options)
    } else {
      api.reload('96316496', component.options)
    }
    module.hot.accept("./alocacao-estrategica.vue?vue&type=template&id=96316496&", function () {
      api.rerender('96316496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/alocacao-estrategica/alocacao-estrategica.vue"
export default component.exports